// Centralized company contact information
// All contact details should be imported from here to ensure consistency

export const companyInfo = {
  // Company name
  name: "Replenico",
  legalName: "Replenico Ltd",
  
  // Contact details
  email: "hello@replenico.com",
  emailLink: "mailto:hello@replenico.com",
  
  phone: "+44 207 112 8733",
  phoneLink: "tel:+442071128733",
  phoneFormatted: "+44 207 112 8733",
  
  // Support portal
  supportPortal: "https://support.replenico.co.uk",
  supportEmail: "hello@replenico.com",
  
  // Address
  address: {
    line1: "Videk House, Building 2",
    line2: "Kingsbury Road",
    city: "London",
    postcode: "NW9 8RW",
    country: "United Kingdom",
  },
  
  // Social links (add as needed)
  social: {
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },
  
  // Operating hours
  serviceHours: {
    deliveries: "24 Hours A Day, 7 Days A Week",
  },
  
  officeHours: {
    weekdays: "Monday - Friday",
    weekdayTimes: "9:00 AM - 5:30 PM",
    saturday: "Closed",
    sunday: "Closed",
  },
  
  // Support availability
  support: {
    available247: true,
    description: "Support available 24/7",
  },
} as const;

// Helper to format phone for display
export const formatPhone = (phone: string): string => {
  return phone.replace(/(\+44)(\d{3})(\d{3})(\d{4})/, "$1 $2 $3 $4");
};

// Export operating hours in the existing format for backward compatibility
export interface OperatingHours {
  day: string;
  hours: string;
  link?: string;
  type?: 'phone' | 'email';
}

export interface OperatingHoursSection {
  title: string;
  hours: OperatingHours[];
}

export const operatingHours: OperatingHoursSection[] = [
  {
    title: "Service Hours",
    hours: [
      { day: "Deliveries", hours: companyInfo.serviceHours.deliveries },
    ]
  },
  {
    title: "Office/Support Hours",
    hours: [
      { day: companyInfo.officeHours.weekdays, hours: companyInfo.officeHours.weekdayTimes },
      { day: "Phone Support", hours: companyInfo.phone, link: companyInfo.phoneLink, type: "phone" },
      { day: "Email Support", hours: companyInfo.email, link: companyInfo.emailLink, type: "email" }
    ]
  }
];

export default companyInfo;
